import { defineMessages } from '@cookbook/solid-intl'

export const messages = defineMessages({
    currencyLockedNotice: {
        defaultMessage: 'Currency cannot be changed while in the checkout.',
        id: 'LocaleSelectModal.currencyLockedNotice',
    },
    currencySection: {
        defaultMessage: 'Choose a currency',
        id: 'LocaleSelectModal.currencySection',
    },
    languageSection: {
        defaultMessage: 'Choose a language',
        id: 'LocaleSelectModal.languageSection',
    },
    saveButton: {
        defaultMessage: 'Save',
        id: 'LocaleSelectModal.saveButton',
    },
    title: {
        defaultMessage: 'Language and currency',
        id: 'LocaleSelectModal.title',
    },
})
